import React from 'react';

import { Link, type LinkProps } from 'components/RouterLink';
import { useI18n } from 'i18n/I18nContext';

/**
 * Same as react-router Link but prefixes `/nl` when the active locale is Dutch.
 */
const LocalizedLink = ({ to, ...rest }: LinkProps) => {
  const { localizePath } = useI18n();
  const localizedTo = typeof to === 'string' ? localizePath(to) : to;
  return <Link to={localizedTo} {...rest} />;
};

export default LocalizedLink;



// WEBPACK FOOTER //
// ./src/components/LocalizedLink.tsx